import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from './assets/cheemz.png'


const _hoisted_1 = { id: "application" }
const _hoisted_2 = { class: "block nav" }
const _hoisted_3 = {
  key: 0,
  class: "block content"
}
const _hoisted_4 = { class: "block footer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  alt: "bonk",
  src: _imports_0
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Footer = _resolveComponent("Footer")
  const _component_easteregg = _resolveComponent("easteregg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Navigation)
    ]),
    (_ctx.cheemz)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Footer)
    ]),
    _createVNode(_component_easteregg, {
      onEaster: _ctx.egg,
      duration: _ctx.duration
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["onEaster", "duration"])
  ]))
}